export function getSuggestionsCount(suggestions) {
  return Object.keys(suggestions).reduce(function (acc, key) {
    var val = suggestions[key];
    return val ? acc + val.length : acc;
  }, 0);
}
export function sortSuggestions(data) {
  var sortOrder = data.sortOrder,
    suggestions = data.suggestions;
  return sortOrder.map(function (item) {
    return suggestions[item];
  });
}